export const quizFlow = {
  en: {
    correct: 'Correct!',
    incorrect: 'Incorrect',
    yourAnswer: 'Your answer',
    correctAnswer: 'Correct answer',
    next: 'Next',
    submit: 'Submit',
    finish: 'Finish',
    resultsTitle: 'Results',
    score: 'Score',
    playAgain: 'Play Again',
    share: 'Share',
    insight: 'Insight',
    digDeeper: 'Read more about this passage',
    continueWhenReady: 'Continue when you\'re ready',
    selectOne: 'Select 1 answer',
    selectMany: 'Select {{count}} answers',
    selectRange: 'Select {{min}}-{{max}} answers',
    fillBlanks: 'Fill in the blanks to complete the passage',
    blanksFilled: '{{filled}} of {{total}} blanks filled',
    partialCreditFillBlank: 'Partial credit enabled: Close matches earn partial points!',
    caseInsensitiveAnswers: 'Answers are not case-sensitive',
    orderItems: 'Arrange the items in the correct order',
    tapToSwap: 'Tap to select, then tap another to swap',
    orderingTakeYourTime: '{{count}} items - take your time',
    submitOrder: 'Submit Order',
    perfectOrder: '✓ Perfect Order!',
    orderNeedsAdjustment: '✗ Order needs adjustment',
    positionLocked: 'Placed',
    correctPosition: 'Should be #{{position}}',
    selectedCorrect: 'Affirmed',
    selectedWrong: 'Your choice',
    missedCorrect: 'Missed',
    partialCreditOrdering: 'Partial credit enabled: Earn points for correct sequences and adjacent pairs!',
    strictOrderingMode: 'Strict mode: Points awarded for each item in correct position',
    flexibleOrderingMode: 'Flexible mode: Credit for correct subsequences and adjacent pairs',
    kingdomJourney: 'Kingdom Journey',
    questionAppears: 'Question Appears',
    answerSubmitted: 'Answer Submitted',
    answersLocked: 'Answers Locked',
    checkingAnswer: 'Let us see what you discovered.',
    wisdomGained: 'Wisdom Gained',
    verseReveal: 'Verse Reveal',
    continueJourney: 'Continue Journey',
    completeJourney: 'Complete Journey',
    keepLearningTogether: 'Let us keep learning together.',
    streak: 'Streak',
    kingdomXp: 'XP',
    hint: 'Hint',
    hintUsed: 'Used',
    hintUseAccessibility: 'Use hint',
    hintUsedAccessibility: 'Hint used',
    correctAnswerWithText: 'The correct answer is {{answer}}. Keep learning together.',
    allCorrectAnswersSelected: 'You selected all the correct answers.',
    verseCompletedCorrectly: 'That is correct! You completed the verse.',
    orderedCorrectly: 'Beautiful! You arranged them correctly.',
    choseRightAnswer: 'Well done! You chose the right answer.',
    instructionMcqSingle: 'Tap the correct answer. One choice is right!',
    instructionMcqMultiple: 'Choose all that apply. More than one is right!',
    instructionTrueFalse: 'Decide if the statement is True or False.',
    instructionFillBlank: 'Type the missing word to complete the verse.',
    instructionOrdering: 'Tap one item, then tap another to swap.',
    typeYourAnswer: 'Type your answer',
    submitFillBlankAnswersAccessibility: 'Submit {{filled}} of {{total}} answers',
    selectionCount: '{{selected}} of {{total}} selected',
    trueAnswer: 'True',
    falseAnswer: 'False',
    optionAccessibility: 'Option {{option}}: {{text}}. {{status}}',
    optionSelectedAccessibility: 'Selected',
    optionNotSelectedAccessibility: 'Not selected',
    submitCurrentOrderAccessibility: 'Submit current order',
    keyboardSpace: 'space',
    keyboardReturn: 'return',
    format_mcq_single: 'Multiple Choice',
    format_mcq_multiple: 'Multiple Select',
    format_true_false: 'True / False',
    format_fill_blank: 'Fill in the Blank',
    format_ordering: 'Ordering',
  },
  es: {
    correct: '¡Correcto!',
    incorrect: 'Incorrecto',
    yourAnswer: 'Tu respuesta',
    correctAnswer: 'Respuesta correcta',
    next: 'Siguiente',
    submit: 'Enviar',
    finish: 'Finalizar',
    resultsTitle: 'Resultados',
    score: 'Puntuación',
    playAgain: 'Jugar de nuevo',
    share: 'Compartir',
    insight: 'Reflexión',
    digDeeper: 'Leer más sobre este pasaje',
    continueWhenReady: 'Continua cuando estes listo',
    selectOne: 'Selecciona 1 respuesta',
    selectMany: 'Selecciona {{count}} respuestas',
    selectRange: 'Selecciona entre {{min}} y {{max}} respuestas',
    fillBlanks: 'Completa los espacios en blanco para completar el pasaje',
    blanksFilled: '{{filled}} de {{total}} espacios completados',
    partialCreditFillBlank: 'Credito parcial activado: las respuestas cercanas obtienen puntos parciales',
    caseInsensitiveAnswers: 'Las respuestas no distinguen mayusculas',
    orderItems: 'Ordena los elementos en el orden correcto',
    tapToSwap: 'Toca para seleccionar y luego toca otro para intercambiar',
    orderingTakeYourTime: '{{count}} elementos - tómate tu tiempo',
    submitOrder: 'Enviar orden',
    perfectOrder: '✓ Orden perfecto',
    orderNeedsAdjustment: '✗ El orden necesita ajuste',
    positionLocked: 'Ubicado',
    correctPosition: 'Debe estar en el n.º {{position}}',
    selectedCorrect: 'Confirmada',
    selectedWrong: 'Tu elección',
    missedCorrect: 'Omitida',
    partialCreditOrdering: 'Credito parcial activado: gana puntos por secuencias correctas y pares adyacentes',
    strictOrderingMode: 'Modo estricto: puntos por cada elemento en la posicion correcta',
    flexibleOrderingMode: 'Modo flexible: credito por subsecuencias correctas y pares adyacentes',
    kingdomJourney: 'Jornada del Reino',
    questionAppears: 'Aparece la pregunta',
    answerSubmitted: 'Respuesta enviada',
    answersLocked: 'Respuestas bloqueadas',
    checkingAnswer: 'Veamos lo que descubriste.',
    wisdomGained: 'Sabiduría ganada',
    verseReveal: 'Versículo revelado',
    continueJourney: 'Continuar jornada',
    completeJourney: 'Completar jornada',
    keepLearningTogether: 'Sigamos aprendiendo juntos.',
    streak: 'Racha',
    kingdomXp: 'XP',
    hint: 'Pista',
    hintUsed: 'Usada',
    hintUseAccessibility: 'Usar pista',
    hintUsedAccessibility: 'Pista usada',
    correctAnswerWithText: 'La respuesta correcta es {{answer}}. Sigamos aprendiendo juntos.',
    allCorrectAnswersSelected: 'Seleccionaste todas las respuestas correctas.',
    verseCompletedCorrectly: '¡Correcto! Completaste el versículo.',
    orderedCorrectly: '¡Muy bien! Las ordenaste correctamente.',
    choseRightAnswer: '¡Bien hecho! Elegiste la respuesta correcta.',
    instructionMcqSingle: 'Toca la respuesta correcta. Solo una opción es correcta.',
    instructionMcqMultiple: 'Elige todas las que correspondan. Más de una es correcta.',
    instructionTrueFalse: 'Decide si la afirmación es verdadera o falsa.',
    instructionFillBlank: 'Escribe la palabra que falta para completar el versículo.',
    instructionOrdering: 'Toca un elemento y luego otro para intercambiarlos.',
    typeYourAnswer: 'Escribe tu respuesta',
    submitFillBlankAnswersAccessibility: 'Enviar {{filled}} de {{total}} respuestas',
    selectionCount: '{{selected}} de {{total}} seleccionadas',
    trueAnswer: 'Verdadero',
    falseAnswer: 'Falso',
    optionAccessibility: 'Opción {{option}}: {{text}}. {{status}}',
    optionSelectedAccessibility: 'Seleccionada',
    optionNotSelectedAccessibility: 'No seleccionada',
    submitCurrentOrderAccessibility: 'Enviar el orden actual',
    keyboardSpace: 'espacio',
    keyboardReturn: 'intro',
    format_mcq_single: 'Opción múltiple',
    format_mcq_multiple: 'Selección múltiple',
    format_true_false: 'Verdadero / Falso',
    format_fill_blank: 'Completar espacio',
    format_ordering: 'Ordenar',
  },
  fr: {
    correct: 'Correct !',
    incorrect: 'Incorrect',
    yourAnswer: 'Votre réponse',
    correctAnswer: 'Bonne réponse',
    next: 'Suivant',
    submit: 'Soumettre',
    finish: 'Terminer',
    resultsTitle: 'Résultats',
    score: 'Score',
    playAgain: 'Rejouer',
    share: 'Partager',
    insight: 'Reflexion',
    digDeeper: 'En savoir plus sur ce passage',
    continueWhenReady: 'Continuez quand vous êtes prêt',
    selectOne: 'Sélectionnez 1 réponse',
    selectMany: 'Sélectionnez {{count}} réponses',
    selectRange: 'Sélectionnez entre {{min}} et {{max}} réponses',
    fillBlanks: 'Remplissez les blancs pour completer le passage',
    blanksFilled: '{{filled}} blancs remplis sur {{total}}',
    partialCreditFillBlank: 'Credit partiel active : les réponses proches gagnent des points partiels',
    caseInsensitiveAnswers: 'Les réponses ne sont pas sensibles a la casse',
    orderItems: 'Placez les elements dans le bon ordre',
    tapToSwap: 'Touchez pour sélectionner puis touchez un autre element pour echanger',
    orderingTakeYourTime: '{{count}} elements - prenez votre temps',
    submitOrder: 'Soumettre l ordre',
    perfectOrder: '✓ Ordre parfait',
    orderNeedsAdjustment: '✗ L ordre doit être ajuste',
    positionLocked: 'Place',
    correctPosition: 'Devrait être en position {{position}}',
    selectedCorrect: 'Confirmee',
    selectedWrong: 'Votre choix',
    missedCorrect: 'Manquee',
    partialCreditOrdering: 'Credit partiel active : gagnez des points pour les bonnes sequences et les paires adjacentes',
    strictOrderingMode: 'Mode strict : points accordes pour chaque element a la bonne position',
    flexibleOrderingMode: 'Mode flexible : credit pour les sous-sequences correctes et les paires adjacentes',
    kingdomJourney: 'Parcours du Royaume',
    questionAppears: 'La question apparait',
    answerSubmitted: 'Réponse envoyée',
    answersLocked: 'Reponses verrouillees',
    checkingAnswer: 'Voyons ce que vous avez decouvert.',
    wisdomGained: 'Sagesse acquise',
    verseReveal: 'Verset revele',
    continueJourney: 'Continuer le parcours',
    completeJourney: 'Terminer le parcours',
    keepLearningTogether: 'Continuons a apprendre ensemble.',
    streak: 'Série',
    kingdomXp: 'XP',
    hint: 'Indice',
    hintUsed: 'Utilise',
    hintUseAccessibility: 'Utiliser un indice',
    hintUsedAccessibility: 'Indice utilise',
    correctAnswerWithText: 'La bonne réponse est {{answer}}. Continuons a apprendre ensemble.',
    allCorrectAnswersSelected: 'Vous avez sélectionné toutes les bonnes réponses.',
    verseCompletedCorrectly: 'C est correct ! Vous avez complete le verset.',
    orderedCorrectly: 'Tres bien ! Vous les avez places correctement.',
    choseRightAnswer: 'Bien joue ! Vous avez choisi la bonne réponse.',
    instructionMcqSingle: 'Touchez la bonne réponse. Une seule option est correcte.',
    instructionMcqMultiple: 'Choisissez toutes les bonnes réponses. Il y en a plusieurs.',
    instructionTrueFalse: 'Decidez si l affirmation est vraie ou fausse.',
    instructionFillBlank: 'Tapez le mot manquant pour completer le verset.',
    instructionOrdering: 'Touchez un element, puis un autre pour les echanger.',
    typeYourAnswer: 'Tapez votre réponse',
    submitFillBlankAnswersAccessibility: 'Envoyer {{filled}} réponses sur {{total}}',
    selectionCount: '{{selected}} sur {{total}} selectionnees',
    trueAnswer: 'Vrai',
    falseAnswer: 'Faux',
    optionAccessibility: 'Option {{option}} : {{text}}. {{status}}',
    optionSelectedAccessibility: 'Selectionnee',
    optionNotSelectedAccessibility: 'Non selectionnee',
    submitCurrentOrderAccessibility: 'Envoyer l ordre actuel',
    keyboardSpace: 'espace',
    keyboardReturn: 'retour',
    format_mcq_single: 'Choix multiple',
    format_mcq_multiple: 'Selection multiple',
    format_true_false: 'Vrai / Faux',
    format_fill_blank: 'Texte a trous',
    format_ordering: 'Ordre',
  },
  de: {
    correct: 'Richtig!',
    incorrect: 'Falsch',
    yourAnswer: 'Ihre Antwort',
    correctAnswer: 'Richtige Antwort',
    next: 'Weiter',
    submit: 'Absenden',
    finish: 'Beenden',
    resultsTitle: 'Ergebnisse',
    score: 'Punktzahl',
    playAgain: 'Nochmal spielen',
    share: 'Teilen',
    insight: 'Erkenntnis',
    digDeeper: 'Mehr über diese Passage erfahren',
    continueWhenReady: 'Fortfahren wenn du bereit bist',
    selectOne: 'Wähle 1 Antwort',
    selectMany: 'Wähle {{count}} Antworten',
    selectRange: 'Wähle {{min}}-{{max}} Antworten',
    fillBlanks: 'Fulle die Lucken aus, um den Abschnitt zu vervollständigen',
    blanksFilled: '{{filled}} von {{total}} Lucken ausgefullt',
    partialCreditFillBlank: 'Teilpunkte aktiviert: Nahe Antworten erhalten Teilpunkte',
    caseInsensitiveAnswers: 'Antworten sind nicht gross- und kleinschreibungssensitiv',
    orderItems: 'Ordne die Elemente in die richtige Reihenfolge',
    tapToSwap: 'Tippe zum Auswahlen und dann auf ein anderes Element zum Tauschen',
    orderingTakeYourTime: '{{count}} Elemente - nimm dir Zeit',
    submitOrder: 'Reihenfolge senden',
    perfectOrder: '✓ Perfekte Reihenfolge',
    orderNeedsAdjustment: '✗ Reihenfolge muss angepasst werden',
    positionLocked: 'Platziert',
    correctPosition: 'Sollte auf Platz {{position}} sein',
    selectedCorrect: 'Bestätigt',
    selectedWrong: 'Deine Wahl',
    missedCorrect: 'Verpasst',
    partialCreditOrdering: 'Teilpunkte aktiviert: Punkte für richtige Sequenzen und benachbarte Paare',
    strictOrderingMode: 'Strenger Modus: Punkte für jedes Element an der richtigen Position',
    flexibleOrderingMode: 'Flexibler Modus: Teilpunkte für korrekte Teilsequenzen und benachbarte Paare',
    kingdomJourney: 'Königreich-Reise',
    questionAppears: 'Frage erscheint',
    answerSubmitted: 'Antwort gesendet',
    answersLocked: 'Antworten gesperrt',
    checkingAnswer: 'Schauen wir, was du entdeckt hast.',
    wisdomGained: 'Weisheit gewonnen',
    verseReveal: 'Vers offenbart',
    continueJourney: 'Reise fortsetzen',
    completeJourney: 'Reise abschliessen',
    keepLearningTogether: 'Lasst uns gemeinsam weiterlernen.',
    streak: 'Serie',
    kingdomXp: 'XP',
    hint: 'Hinweis',
    hintUsed: 'Genutzt',
    hintUseAccessibility: 'Hinweis nutzen',
    hintUsedAccessibility: 'Hinweis genutzt',
    correctAnswerWithText: 'Die richtige Antwort ist {{answer}}. Lasst uns gemeinsam weiterlernen.',
    allCorrectAnswersSelected: 'Du hast alle richtigen Antworten ausgewählt.',
    verseCompletedCorrectly: 'Das ist richtig! Du hast den Vers vervollständigt.',
    orderedCorrectly: 'Sehr gut! Du hast alles richtig geordnet.',
    choseRightAnswer: 'Gut gemacht! Du hast die richtige Antwort gewählt.',
    instructionMcqSingle: 'Tippe auf die richtige Antwort. Eine Option ist richtig.',
    instructionMcqMultiple: 'Wähle alles aus, was zutrifft. Mehr als eine Antwort ist richtig.',
    instructionTrueFalse: 'Entscheide, ob die Aussage richtig oder falsch ist.',
    instructionFillBlank: 'Gib das fehlende Wort ein, um den Vers zu vervollständigen.',
    instructionOrdering: 'Tippe auf ein Element und dann auf ein anderes, um sie zu tauschen.',
    typeYourAnswer: 'Gib deine Antwort ein',
    submitFillBlankAnswersAccessibility: '{{filled}} von {{total}} Antworten senden',
    selectionCount: '{{selected}} von {{total}} ausgewählt',
    trueAnswer: 'Richtig',
    falseAnswer: 'Falsch',
    optionAccessibility: 'Option {{option}}: {{text}}. {{status}}',
    optionSelectedAccessibility: 'Ausgewählt',
    optionNotSelectedAccessibility: 'Nicht ausgewählt',
    submitCurrentOrderAccessibility: 'Aktuelle Reihenfolge senden',
    keyboardSpace: 'Leertaste',
    keyboardReturn: 'Eingabe',
    format_mcq_single: 'Multiple Choice',
    format_mcq_multiple: 'Mehrfachauswahl',
    format_true_false: 'Richtig / Falsch',
    format_fill_blank: 'Lueckentext',
    format_ordering: 'Sortieren',
  },
  pt: {
    correct: 'Correto!',
    incorrect: 'Incorreto',
    yourAnswer: 'Sua resposta',
    correctAnswer: 'Resposta correta',
    next: 'Próximo',
    submit: 'Enviar',
    finish: 'Finalizar',
    resultsTitle: 'Resultados',
    score: 'Pontuação',
    playAgain: 'Jogar novamente',
    share: 'Compartilhar',
    insight: 'Reflexao',
    digDeeper: 'Saiba mais sobre esta passagem',
    continueWhenReady: 'Continue quando estiver pronto',
    selectOne: 'Selecione 1 resposta',
    selectMany: 'Selecione {{count}} respostas',
    selectRange: 'Selecione entre {{min}} e {{max}} respostas',
    fillBlanks: 'Preencha os espacos em branco para completar a passagem',
    blanksFilled: '{{filled}} de {{total}} lacunas preenchidas',
    partialCreditFillBlank: 'Credito parcial ativado: respostas proximas ganham pontos parciais',
    caseInsensitiveAnswers: 'As respostas não diferenciam maiusculas e minusculas',
    orderItems: 'Organize os itens na ordem correta',
    tapToSwap: 'Toque para selecionar e depois toque em outro para trocar',
    orderingTakeYourTime: '{{count}} itens - leve o tempo necessario',
    submitOrder: 'Enviar ordem',
    perfectOrder: '✓ Ordem perfeita',
    orderNeedsAdjustment: '✗ A ordem precisa de ajuste',
    positionLocked: 'Posicionado',
    correctPosition: 'Deve ficar na posicao {{position}}',
    selectedCorrect: 'Confirmada',
    selectedWrong: 'Sua escolha',
    missedCorrect: 'Perdida',
    partialCreditOrdering: 'Credito parcial ativado: ganhe pontos por sequências corretas e pares adjacentes',
    strictOrderingMode: 'Modo estrito: pontos para cada item na posicao correta',
    flexibleOrderingMode: 'Modo flexivel: credito para subsequencias corretas e pares adjacentes',
    kingdomJourney: 'Jornada do Reino',
    questionAppears: 'Pergunta aparece',
    answerSubmitted: 'Resposta enviada',
    answersLocked: 'Respostas bloqueadas',
    checkingAnswer: 'Vamos ver o que você descobriu.',
    wisdomGained: 'Sabedoria adquirida',
    verseReveal: 'Versículo revelado',
    continueJourney: 'Continuar jornada',
    completeJourney: 'Concluir jornada',
    keepLearningTogether: 'Vamos continuar aprendendo juntos.',
    streak: 'Sequência',
    kingdomXp: 'XP',
    hint: 'Dica',
    hintUsed: 'Usada',
    hintUseAccessibility: 'Usar dica',
    hintUsedAccessibility: 'Dica usada',
    correctAnswerWithText: 'A resposta correta é {{answer}}. Vamos continuar aprendendo juntos.',
    allCorrectAnswersSelected: 'Você selecionou todas as respostas corretas.',
    verseCompletedCorrectly: 'Isso está correto! Você completou o versículo.',
    orderedCorrectly: 'Muito bem! Você organizou tudo corretamente.',
    choseRightAnswer: 'Muito bem! Você escolheu a resposta correta.',
    instructionMcqSingle: 'Toque na resposta correta. Apenas uma opção está certa.',
    instructionMcqMultiple: 'Escolha todas as opções corretas. Mais de uma está certa.',
    instructionTrueFalse: 'Decida se a afirmação é verdadeira ou falsa.',
    instructionFillBlank: 'Digite a palavra que falta para completar o versículo.',
    instructionOrdering: 'Toque em um item e depois em outro para trocar.',
    typeYourAnswer: 'Digite sua resposta',
    submitFillBlankAnswersAccessibility: 'Enviar {{filled}} de {{total}} respostas',
    selectionCount: '{{selected}} de {{total}} selecionadas',
    trueAnswer: 'Verdadeiro',
    falseAnswer: 'Falso',
    optionAccessibility: 'Opção {{option}}: {{text}}. {{status}}',
    optionSelectedAccessibility: 'Selecionada',
    optionNotSelectedAccessibility: 'Não selecionada',
    submitCurrentOrderAccessibility: 'Enviar ordem atual',
    keyboardSpace: 'espaço',
    keyboardReturn: 'retorno',
    format_mcq_single: 'Multipla escolha',
    format_mcq_multiple: 'Selecao multipla',
    format_true_false: 'Verdadeiro / Falso',
    format_fill_blank: 'Preencher lacuna',
    format_ordering: 'Ordenacao',
  },
  ru: {
    correct: 'Правильно!',
    incorrect: 'Неправильно',
    yourAnswer: 'Ваш ответ',
    correctAnswer: 'Правильный ответ',
    next: 'Далее',
    submit: 'Отправить',
    finish: 'Завершить',
    resultsTitle: 'Результаты',
    score: 'Счет',
    playAgain: 'Играть снова',
    share: 'Поделиться',
    insight: 'Размышление',
    digDeeper: 'Узнать больше об этом отрывке',
    continueWhenReady: 'Продолжайте когда будете готовы',
    selectOne: 'Выберите 1 ответ',
    selectMany: 'Выберите {{count}} ответа',
    selectRange: 'Выберите от {{min}} до {{max}} ответов',
    fillBlanks: 'Заполните пропуски, чтобы завершить отрывок',
    blanksFilled: 'Заполнено {{filled}} из {{total}} пропусков',
    partialCreditFillBlank: 'Частичное начисление включено: близкие ответы получают часть баллов',
    caseInsensitiveAnswers: 'Ответы не чувствительны к регистру',
    orderItems: 'Расположите элементы в правильном порядке',
    tapToSwap: 'Нажмите, чтобы выбрать, затем нажмите другой элемент для обмена',
    orderingTakeYourTime: '{{count}} элементов - не спешите',
    submitOrder: 'Отправить порядок',
    perfectOrder: '✓ Идеальный порядок',
    orderNeedsAdjustment: '✗ Порядок нужно исправить',
    positionLocked: 'На месте',
    correctPosition: 'Должно быть на позиции {{position}}',
    selectedCorrect: 'Подтверждено',
    selectedWrong: 'Ваш выбор',
    missedCorrect: 'Пропущено',
    partialCreditOrdering: 'Частичное начисление включено: получайте баллы за правильные последовательности и соседние пары',
    strictOrderingMode: 'Строгий режим: баллы за каждый элемент на правильной позиции',
    flexibleOrderingMode: 'Гибкий режим: баллы за правильные подпоследовательности и соседние пары',
    kingdomJourney: 'Путь Царства',
    questionAppears: 'Вопрос появляется',
    answerSubmitted: 'Ответ отправлен',
    answersLocked: 'Ответы зафиксированы',
    checkingAnswer: 'Посмотрим, что вы открыли.',
    wisdomGained: 'Мудрость получена',
    verseReveal: 'Стих открыт',
    continueJourney: 'Продолжить путь',
    completeJourney: 'Завершить путь',
    keepLearningTogether: 'Продолжим учиться вместе.',
    streak: 'Серия',
    kingdomXp: 'XP',
    hint: 'Подсказка',
    hintUsed: 'Использовано',
    hintUseAccessibility: 'Использовать подсказку',
    hintUsedAccessibility: 'Подсказка использована',
    correctAnswerWithText: 'Правильный ответ: {{answer}}. Продолжим учиться вместе.',
    allCorrectAnswersSelected: 'Вы выбрали все правильные ответы.',
    verseCompletedCorrectly: 'Верно! Вы завершили стих.',
    orderedCorrectly: 'Отлично! Вы расположили все правильно.',
    choseRightAnswer: 'Хорошо! Вы выбрали правильный ответ.',
    instructionMcqSingle: 'Нажмите на правильный ответ. Верен только один вариант.',
    instructionMcqMultiple: 'Выберите все подходящие варианты. Правильных ответов больше одного.',
    instructionTrueFalse: 'Решите, верно или неверно это утверждение.',
    instructionFillBlank: 'Введите пропущенное слово, чтобы завершить стих.',
    instructionOrdering: 'Нажмите один элемент, затем другой, чтобы поменять их местами.',
    typeYourAnswer: 'Введите ответ',
    submitFillBlankAnswersAccessibility: 'Отправить {{filled}} из {{total}} ответов',
    selectionCount: 'Выбрано {{selected}} из {{total}}',
    trueAnswer: 'Верно',
    falseAnswer: 'Неверно',
    optionAccessibility: 'Вариант {{option}}: {{text}}. {{status}}',
    optionSelectedAccessibility: 'Выбрано',
    optionNotSelectedAccessibility: 'Не выбрано',
    submitCurrentOrderAccessibility: 'Отправить текущий порядок',
    keyboardSpace: 'пробел',
    keyboardReturn: 'ввод',
    format_mcq_single: 'Выбор ответа',
    format_mcq_multiple: 'Несколько ответов',
    format_true_false: 'Верно / Неверно',
    format_fill_blank: 'Заполнить пропуск',
    format_ordering: 'Порядок',
  },
  tl: {
    correct: 'Tama!',
    incorrect: 'Mali',
    yourAnswer: 'Inyong sagot',
    correctAnswer: 'Tamang sagot',
    next: 'Susunod',
    submit: 'Ipasa',
    finish: 'Tapos',
    resultsTitle: 'Mga resulta',
    score: 'Puntos',
    playAgain: 'Maglaro ulit',
    share: 'I-share',
    insight: 'Pagninilay',
    digDeeper: 'Magbasa pa tungkol sa talatang ito',
    continueWhenReady: 'Magpatuloy kapag handa ka na',
    selectOne: 'Pumili ng 1 sagot',
    selectMany: 'Pumili ng {{count}} sagot',
    selectRange: 'Pumili ng {{min}}-{{max}} sagot',
    fillBlanks: 'Punan ang mga patlang upang makumpleto ang talata',
    blanksFilled: '{{filled}} sa {{total}} na patlang ang napunan',
    partialCreditFillBlank: 'May partial credit: ang malalapit na sagot ay may bahagyang puntos',
    caseInsensitiveAnswers: 'Hindi sensitibo sa laki ng titik ang mga sagot',
    orderItems: 'Ayusin ang mga item sa tamang pagkakasunod-sunod',
    tapToSwap: 'Tapikin para pumili, tapos tapikin ang iba para magpalit',
    orderingTakeYourTime: '{{count}} item - dahan-dahan lang',
    submitOrder: 'Ipasa ang ayos',
    perfectOrder: '✓ Perpektong ayos',
    orderNeedsAdjustment: '✗ Kailangang ayusin ang pagkakasunod-sunod',
    positionLocked: 'Nailagay',
    correctPosition: 'Dapat nasa #{{position}}',
    selectedCorrect: 'Nakumpirma',
    selectedWrong: 'Iyong pinili',
    missedCorrect: 'Nalampasan',
    partialCreditOrdering: 'May partial credit: makakuha ng puntos sa tamang pagkakasunod at magkatabing pares',
    strictOrderingMode: 'Strict mode: puntos para sa bawat item na nasa tamang posisyon',
    flexibleOrderingMode: 'Flexible mode: credit para sa tamang subsequence at magkatabing pares',
    kingdomJourney: 'Paglalakbay sa Kaharian',
    questionAppears: 'Lalabas ang tanong',
    answerSubmitted: 'Naipasa ang sagot',
    answersLocked: 'Naka-lock ang mga sagot',
    checkingAnswer: 'Tingnan natin ang iyong natuklasan.',
    wisdomGained: 'Karunungan nakuha',
    verseReveal: 'Talata ipinakita',
    continueJourney: 'Ipagpatuloy ang paglalakbay',
    completeJourney: 'Tapusin ang paglalakbay',
    keepLearningTogether: 'Patuloy tayong matuto nang magkasama.',
    streak: 'Sunod-sunod',
    kingdomXp: 'XP',
    hint: 'Hint',
    hintUsed: 'Nagamit',
    hintUseAccessibility: 'Gumamit ng hint',
    hintUsedAccessibility: 'Nagamit na ang hint',
    correctAnswerWithText: 'Ang tamang sagot ay {{answer}}. Patuloy tayong matuto nang magkasama.',
    allCorrectAnswersSelected: 'Napili mo ang lahat ng tamang sagot.',
    verseCompletedCorrectly: 'Tama iyan! Nabuo mo ang talata.',
    orderedCorrectly: 'Mahusay! Naayos mo nang tama ang mga ito.',
    choseRightAnswer: 'Mahusay! Pinili mo ang tamang sagot.',
    instructionMcqSingle: 'I-tap ang tamang sagot. Isang pagpipilian lang ang tama.',
    instructionMcqMultiple: 'Piliin ang lahat ng tama. Higit sa isa ang tamang sagot.',
    instructionTrueFalse: 'Tukuyin kung tama o mali ang pahayag.',
    instructionFillBlank: 'I-type ang nawawalang salita para mabuo ang talata.',
    instructionOrdering: 'I-tap ang isang item, tapos i-tap ang isa pa para magpalit.',
    typeYourAnswer: 'I-type ang iyong sagot',
    submitFillBlankAnswersAccessibility: 'Ipasa ang {{filled}} sa {{total}} sagot',
    selectionCount: '{{selected}} sa {{total}} ang napili',
    trueAnswer: 'Tama',
    falseAnswer: 'Mali',
    optionAccessibility: 'Opsyon {{option}}: {{text}}. {{status}}',
    optionSelectedAccessibility: 'Napili',
    optionNotSelectedAccessibility: 'Hindi napili',
    submitCurrentOrderAccessibility: 'Ipasa ang kasalukuyang ayos',
    keyboardSpace: 'espasyo',
    keyboardReturn: 'return',
    format_mcq_single: 'Multiple choice',
    format_mcq_multiple: 'Multiple select',
    format_true_false: 'Tama / Mali',
    format_fill_blank: 'Punan ang patlang',
    format_ordering: 'Ayusin',
  },
  it: {
    correct: 'Corretto!',
    incorrect: 'Sbagliato',
    yourAnswer: 'La tua risposta',
    correctAnswer: 'Risposta corretta',
    next: 'Avanti',
    submit: 'Invia',
    finish: 'Fine',
    resultsTitle: 'Risultati',
    score: 'Punteggio',
    playAgain: 'Gioca ancora',
    share: 'Condividi',
    insight: 'Riflessione',
    digDeeper: 'Scopri di più su questo brano',
    continueWhenReady: 'Continua quando sei pronto',
    selectOne: 'Seleziona 1 risposta',
    selectMany: 'Seleziona {{count}} risposte',
    selectRange: 'Seleziona tra {{min}} e {{max}} risposte',
    fillBlanks: 'Completa gli spazi vuoti per completare il passaggio',
    blanksFilled: '{{filled}} spazi compilati su {{total}}',
    partialCreditFillBlank: 'Credito parziale attivo: le risposte vicine ottengono punti parziali',
    caseInsensitiveAnswers: 'Le risposte non distinguono tra maiuscole e minuscole',
    orderItems: 'Disponi gli elementi nell ordine corretto',
    tapToSwap: 'Tocca per selezionare, poi tocca un altro elemento per scambiare',
    orderingTakeYourTime: '{{count}} elementi - prenditi il tuo tempo',
    submitOrder: 'Invia ordine',
    perfectOrder: '✓ Ordine perfetto',
    orderNeedsAdjustment: '✗ L ordine va corretto',
    positionLocked: 'Posizionato',
    correctPosition: 'Dovrebbe essere al n. {{position}}',
    selectedCorrect: 'Confermata',
    selectedWrong: 'La tua scelta',
    missedCorrect: 'Mancata',
    partialCreditOrdering: 'Credito parziale attivo: guadagna punti per sequenze corrette e coppie adiacenti',
    strictOrderingMode: 'Modalità rigorosa: punti per ogni elemento nella posizione corretta',
    flexibleOrderingMode: 'Modalità flessibile: credito per sottosequenze corrette e coppie adiacenti',
    kingdomJourney: 'Viaggio del Regno',
    questionAppears: 'Domanda in arrivo',
    answerSubmitted: 'Risposta inviata',
    answersLocked: 'Risposte bloccate',
    checkingAnswer: 'Vediamo cosa hai scoperto.',
    wisdomGained: 'Saggezza acquisita',
    verseReveal: 'Versetto rivelato',
    continueJourney: 'Continua il viaggio',
    completeJourney: 'Completa il viaggio',
    keepLearningTogether: 'Continuiamo a imparare insieme.',
    streak: 'Serie',
    kingdomXp: 'XP',
    hint: 'Aiuto',
    hintUsed: 'Usato',
    hintUseAccessibility: 'Usa aiuto',
    hintUsedAccessibility: 'Aiuto usato',
    correctAnswerWithText: 'La risposta corretta è {{answer}}. Continuiamo a imparare insieme.',
    allCorrectAnswersSelected: 'Hai selezionato tutte le risposte corrette.',
    verseCompletedCorrectly: 'Corretto! Hai completato il versetto.',
    orderedCorrectly: 'Ottimo! Le hai ordinate correttamente.',
    choseRightAnswer: 'Ben fatto! Hai scelto la risposta giusta.',
    instructionMcqSingle: 'Tocca la risposta corretta. Solo una opzione è giusta.',
    instructionMcqMultiple: 'Scegli tutte le risposte corrette. Ce ne è più di una.',
    instructionTrueFalse: 'Decidi se l affermazione è vera o falsa.',
    instructionFillBlank: 'Scrivi la parola mancante per completare il versetto.',
    instructionOrdering: 'Tocca un elemento, poi un altro per scambiarli.',
    typeYourAnswer: 'Scrivi la tua risposta',
    submitFillBlankAnswersAccessibility: 'Invia {{filled}} risposte su {{total}}',
    selectionCount: '{{selected}} su {{total}} selezionate',
    trueAnswer: 'Vero',
    falseAnswer: 'Falso',
    optionAccessibility: 'Opzione {{option}}: {{text}}. {{status}}',
    optionSelectedAccessibility: 'Selezionata',
    optionNotSelectedAccessibility: 'Non selezionata',
    submitCurrentOrderAccessibility: 'Invia ordine attuale',
    keyboardSpace: 'spazio',
    keyboardReturn: 'invio',
    format_mcq_single: 'Scelta multipla',
    format_mcq_multiple: 'Selezione multipla',
    format_true_false: 'Vero / Falso',
    format_fill_blank: 'Completa lo spazio',
    format_ordering: 'Ordina',
  },
  am: {
    correct: 'ትክክል!',
    incorrect: 'ስህተት',
    yourAnswer: 'የእርስዎ መልስ',
    correctAnswer: 'ትክክለኛ መልስ',
    next: 'ቀጣይ',
    submit: 'አስገባ',
    finish: 'ጨርስ',
    resultsTitle: 'ውጤቶች',
    score: 'ነጥብ',
    playAgain: 'እንደገና ተጫወት',
    share: 'አጋራ',
    insight: 'ግንዛቤ',
    digDeeper: 'ስለዚህ ምንባብ ተጨማሪ ያንብቡ',
    continueWhenReady: 'ዝግጁ ሲሆኑ ይቀጥሉ',
    selectOne: '1 መልስ ይምረጡ',
    selectMany: '{{count}} መልሶችን ይምረጡ',
    selectRange: '{{min}}-{{max}} መልሶችን ይምረጡ',
    fillBlanks: 'ክፍተቶቹን ሞልተው ንባቡን ያጠናቅቁ',
    blanksFilled: '{{total}} ውስጥ {{filled}} ክፍተቶች ተሞልተዋል',
    partialCreditFillBlank: 'ከፊል ነጥብ ተከፍቷል፤ ቅርብ መልሶች ከፊል ነጥብ ያገኛሉ',
    caseInsensitiveAnswers: 'መልሶች በፊደል መጠን አይለዩም',
    orderItems: 'ንጥሎቹን በትክክለኛው ቅደም ተከተል ያዘጋጁ',
    tapToSwap: 'ለመምረጥ ይንኩ፣ ከዚያ ለመቀያየር ሌላውን ይንኩ',
    orderingTakeYourTime: '{{count}} ንጥሎች - ጊዜዎን ይውሰዱ',
    submitOrder: 'ቅደም ተከተሉን ያስገቡ',
    perfectOrder: '✓ ፍጹም ቅደም ተከተል',
    orderNeedsAdjustment: '✗ ቅደም ተከተሉ ማስተካከያ ይፈልጋል',
    positionLocked: 'ተቀምጧል',
    correctPosition: 'በ#{{position}} ላይ መሆን አለበት',
    selectedCorrect: 'ተረጋግጧል',
    selectedWrong: 'የእርስዎ ምርጫ',
    missedCorrect: 'ያመለጠ',
    partialCreditOrdering: 'ከፊል ነጥብ ተከፍቷል፤ ለትክክለኛ ቅደም ተከተሎችና አጠገብ ጥንዶች ነጥብ ያግኙ',
    strictOrderingMode: 'ጥብቅ ሁኔታ፡ በትክክለኛ ቦታ ላይ ላለ እያንዳንዱ ንጥል ነጥብ',
    flexibleOrderingMode: 'ተለዋዋጭ ሁኔታ፡ ለትክክለኛ ንዑስ ቅደም ተከተሎችና አጠገብ ጥንዶች ክሬዲት',
    kingdomJourney: 'የመንግሥት ጉዞ',
    questionAppears: 'ጥያቄ ታየ',
    answerSubmitted: 'መልስ ተልኳል',
    answersLocked: 'መልሶች ተቆልፈዋል',
    checkingAnswer: 'ያገኙትን እንመልከት።',
    wisdomGained: 'ጥበብ ተገኘ',
    verseReveal: 'ቁጥር ተገለጠ',
    continueJourney: 'ጉዞውን ቀጥል',
    completeJourney: 'ጉዞውን ጨርስ',
    keepLearningTogether: 'አብረን መማራችንን እንቀጥል።',
    streak: 'ተከታታይ',
    kingdomXp: 'XP',
    hint: 'ፍንጭ',
    hintUsed: 'ተጠቅመዋል',
    hintUseAccessibility: 'ፍንጭ ተጠቀም',
    hintUsedAccessibility: 'ፍንጭ ተጠቅመዋል',
    correctAnswerWithText: 'ትክክለኛው መልስ {{answer}} ነው። አብረን መማራችንን እንቀጥል።',
    allCorrectAnswersSelected: 'ሁሉንም ትክክለኛ መልሶች መርጠዋል።',
    verseCompletedCorrectly: 'ትክክል ነው! ቁጥሩን አጠናቀዋል።',
    orderedCorrectly: 'ጥሩ ነው! በትክክል አዘጋጅተዋል።',
    choseRightAnswer: 'ጥሩ ነው! ትክክለኛውን መልስ መርጠዋል።',
    instructionMcqSingle: 'ትክክለኛውን መልስ ይንኩ። አንድ ምርጫ ብቻ ትክክል ነው።',
    instructionMcqMultiple: 'የሚመለከቱትን ሁሉ ይምረጡ። ከአንድ በላይ ትክክል ነው።',
    instructionTrueFalse: 'መግለጫው እውነት ወይም ሐሰት መሆኑን ይወስኑ።',
    instructionFillBlank: 'ቁጥሩን ለማጠናቀቅ የጎደለውን ቃል ይጻፉ።',
    instructionOrdering: 'አንድ ንጥል ይንኩ፣ ከዚያ ለመቀያየር ሌላውን ይንኩ።',
    typeYourAnswer: 'መልስዎን ይጻፉ',
    submitFillBlankAnswersAccessibility: 'ከ{{total}} ውስጥ {{filled}} መልሶችን ያስገቡ',
    selectionCount: 'ከ{{total}} ውስጥ {{selected}} ተመርጠዋል',
    trueAnswer: 'እውነት',
    falseAnswer: 'ሐሰት',
    optionAccessibility: 'ምርጫ {{option}}፡ {{text}}። {{status}}',
    optionSelectedAccessibility: 'ተመርጧል',
    optionNotSelectedAccessibility: 'አልተመረጠም',
    submitCurrentOrderAccessibility: 'የአሁኑን ቅደም ተከተል ያስገቡ',
    keyboardSpace: 'ክፍተት',
    keyboardReturn: 'መመለስ',
    format_mcq_single: 'ብዙ ምርጫ',
    format_mcq_multiple: 'ብዙ መልስ',
    format_true_false: 'እውነት / ሐሰት',
    format_fill_blank: 'ባዶውን ሙላ',
    format_ordering: 'ቅደም ተከተል',
  },
  ko: {
    correct: '정답!',
    incorrect: '오답',
    yourAnswer: '당신의 답',
    correctAnswer: '정답',
    next: '다음',
    submit: '제출',
    finish: '완료',
    resultsTitle: '결과',
    score: '점수',
    playAgain: '다시 플레이',
    share: '공유',
    insight: '통찰',
    digDeeper: '이 구절에 대해 더 알아보기',
    continueWhenReady: '준비되면 계속하세요',
    selectOne: '답 1개를 선택하세요',
    selectMany: '답 {{count}}개를 선택하세요',
    selectRange: '답 {{min}}-{{max}}개를 선택하세요',
    fillBlanks: '구절을 완성하려면 빈칸을 채우세요',
    blanksFilled: '{{total}}개 중 {{filled}}개 빈칸 채움',
    partialCreditFillBlank: '부분 점수 사용 가능: 가까운 답도 부분 점수를 받습니다',
    caseInsensitiveAnswers: '답은 대소문자를 구분하지 않습니다',
    orderItems: '항목을 올바른 순서로 배열하세요',
    tapToSwap: '선택하려면 탭하고, 바꾸려면 다른 항목을 탭하세요',
    orderingTakeYourTime: '{{count}}개 항목 - 천천히 하세요',
    submitOrder: '순서 제출',
    perfectOrder: '✓ 완벽한 순서',
    orderNeedsAdjustment: '✗ 순서를 조정해야 합니다',
    positionLocked: '배치됨',
    correctPosition: '#{{position}} 위치여야 합니다',
    selectedCorrect: '확인됨',
    selectedWrong: '내 선택',
    missedCorrect: '놓침',
    partialCreditOrdering: '부분 점수 사용 가능: 올바른 순서와 인접한 쌍에 점수를 줍니다',
    strictOrderingMode: '엄격 모드: 올바른 위치의 각 항목에 점수 부여',
    flexibleOrderingMode: '유연 모드: 올바른 부분 수열과 인접 쌍에 대한 점수',
    kingdomJourney: '왕국 여정',
    questionAppears: '문제 등장',
    answerSubmitted: '답변 제출됨',
    answersLocked: '답변 잠김',
    checkingAnswer: '무엇을 발견했는지 볼게요.',
    wisdomGained: '지혜를 얻었습니다',
    verseReveal: '말씀 공개',
    continueJourney: '여정 계속하기',
    completeJourney: '여정 완료하기',
    keepLearningTogether: '함께 계속 배워요.',
    streak: '연속',
    kingdomXp: 'XP',
    hint: '힌트',
    hintUsed: '사용됨',
    hintUseAccessibility: '힌트 사용',
    hintUsedAccessibility: '힌트 사용됨',
    correctAnswerWithText: '정답은 {{answer}}입니다. 함께 계속 배워요.',
    allCorrectAnswersSelected: '모든 정답을 선택했습니다.',
    verseCompletedCorrectly: '맞습니다! 말씀을 완성했습니다.',
    orderedCorrectly: '좋아요! 올바르게 배열했습니다.',
    choseRightAnswer: '잘했습니다! 정답을 선택했습니다.',
    instructionMcqSingle: '정답을 탭하세요. 하나의 선택지만 맞습니다.',
    instructionMcqMultiple: '해당하는 것을 모두 고르세요. 정답이 여러 개입니다.',
    instructionTrueFalse: '문장이 참인지 거짓인지 판단하세요.',
    instructionFillBlank: '말씀을 완성할 빠진 단어를 입력하세요.',
    instructionOrdering: '항목 하나를 탭한 다음 다른 항목을 탭해 바꾸세요.',
    typeYourAnswer: '답을 입력하세요',
    submitFillBlankAnswersAccessibility: '{{total}}개 중 {{filled}}개 답 제출',
    selectionCount: '{{total}}개 중 {{selected}}개 선택됨',
    trueAnswer: '참',
    falseAnswer: '거짓',
    optionAccessibility: '선택지 {{option}}: {{text}}. {{status}}',
    optionSelectedAccessibility: '선택됨',
    optionNotSelectedAccessibility: '선택되지 않음',
    submitCurrentOrderAccessibility: '현재 순서 제출',
    keyboardSpace: '스페이스',
    keyboardReturn: '리턴',
    format_mcq_single: '객관식',
    format_mcq_multiple: '복수 선택',
    format_true_false: '참 / 거짓',
    format_fill_blank: '빈칸 채우기',
    format_ordering: '순서 맞추기',
  },
};
